export default {
    setLoading(state, loading)
    {
        state.loading = loading;
    },
    setInventory(state, {inventory})
    {
        state.inventory = inventory;
    }
}
